module.exports = __webpack_public_path__ + "static/media/Italia.0f077b03.svg";